
import { useCallback, useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { loginReducer, isshowReducer } from "../../../../shared/ReduxStore/Reducers/loginReducer";
import bgIcon from "../../../../assets/images/illustration.png";
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import Spinner from '../../common/Spinner/Spinner';
import axios from 'axios';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService';
import { filterableColumn } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';

function Copyright(props) {
}

const mandatoryColumnList = [
  { entity: "movements", mandatoryColumns: "id~status~weight~volume~loadingLength~quantity~netWeight~instructionsExist~qualificationsExist~onHold" },
  { entity: "movementGood", mandatoryColumns: "id" },
  { entity: "movementAction", mandatoryColumns: "id" },
  { entity: "transportAddresses", mandatoryColumns: "id" },
  { entity: "shipmentActions", mandatoryColumns: "id" },
  { entity: "problemCodes", mandatoryColumns: "id" },
  { entity: "departments", mandatoryColumns: "id" },
  { entity: "subdepartments", mandatoryColumns: "id" },
  { entity: "movementStatus", mandatoryColumns: "id" },
  { entity: "userSetting", mandatoryColumns: "id" },
  { entity: "shipmentInstruction", mandatoryColumns: "id~shipmentNo~language~lineNo" },
  { entity: "transportQualification", mandatoryColumns: "id~type~documentNo~seqNo" },
  { entity: "partialTrips", mandatoryColumns: "id~status~instructionsExist" },
  { entity: "routes", mandatoryColumns: "id~lineNo~sequenceNo" },
  { entity: "ptmovements", mandatoryColumns: "id~systemId~shipmentNo~movementNo~tripNo" },
  { entity: "routeDetail", mandatoryColumns: "id" },
  { entity: "routeGuide", mandatoryColumns: "id~code" },
  { entity: "drivers", mandatoryColumns: "id" },
  { entity: "subcontractors", mandatoryColumns: "id" },
  { entity: "trailers", mandatoryColumns: "id" },
  { entity: "vehicles", mandatoryColumns: "id" },
  { entity: "variousResources", mandatoryColumns: "id" },
  { entity: "postCodes", mandatoryColumns: "id" },
  { entity: "departments", mandatoryColumns: "id" },
  { entity: "subdepartments", mandatoryColumns: "id" },
  { entity: "problemCodes", mandatoryColumns: "id" },
  { entity: "planGroupResources", mandatoryColumns: "id" },
  { entity: "transportAddress", mandatoryColumns: "id~depot" }
]
// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();
let apiService = commonApiService();
let dataService = dataStorageService();

const Login = (props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    // const code = localStorage.getItem('code');

    if (!_.isNil(accessToken)) {
      window.location.href = `${process.env.REACT_APP_REDIRECT_URL}#/dashboard`;
    } else if (props?.authCode != null) {
      generateToken(props?.authCode);
    } else if (accessToken === null) {
      window.location.href = apiService.generateMsAuthUrl();
    }
  }, [])

  function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
    return JSON.parse(jsonPayload);
  }

  const generateToken = async (code) => {
    setIsLoading(true)
    const tokenEndpoint = process.env.REACT_APP_TOKEN_URL;
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_REDIRECT_URL;
    const authCode = code;
    const codeVerifier = localStorage.getItem("codeVerifier")

    await axios.post(tokenEndpoint, {
      grant_type: 'authorization_code',
      client_id: clientId,
      redirect_uri: redirectUri,
      code: authCode,
      code_verifier: codeVerifier,
    }, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }).then(async (res) => {
      localStorage.removeItem("codeVerifier")
      localStorage.setItem('mandatoryColumnList', JSON.stringify(mandatoryColumnList));
      localStorage.setItem("refreshToken", res.data.refresh_token)
      localStorage.setItem("accessToken", res.data.access_token)
      localStorage.setItem("expires_on", res.data.expires_on)
      localStorage.setItem("tokenTimeStamp", Math.floor(Date.now() / 1000))
      const decodedToken = parseJwt(res.data.access_token);
      const tenantId = decodedToken.tid;
      localStorage.setItem("tenantId", tenantId)
      // localStorage.setItem('userID', decodedToken.oid);
      localStorage.setItem('userName', decodedToken.name);
      localStorage.setItem('userMail', decodedToken.unique_name);
      localStorage.setItem('userIdSettings', "04becb79-3373-ee11-a129-002248843480");
      setIsLoading(false)

      const fetchDataAndSetLocalStorage = async () => {
        return new Promise(async (resolve, reject) => {
          try {
            const url = `${process.env.REACT_APP_COMMON_API_URL}companies`
            const res = await apiService.get(url);

            if (res !== null && res !== undefined) {
              dataService.setLocalStorageData("companyId", res.value[0].id)
              const userSettingURL = `${process.env.REACT_APP_COMMON_API_URL}companies(${res.value[0].id})/userSettings`;

              const userSettingRes = await apiService.get(userSettingURL);
              if (userSettingRes !== null && userSettingRes !== undefined) {
                const userData = userSettingRes.value.filter((item) => {
                  if (item.email.indexOf('#EXT#') != -1) {
                    return item.email.indexOf(decodedToken.unique_name.replace('@', '_')) != -1
                  } else {
                    return item.email === decodedToken.unique_name
                  }
                });
                if (userData[0].companyId === null && userData[0].companyId === "") {
                  window.location.href = `${process.env.REACT_APP_REDIRECT_URL}#/companyNotFound`;
                  return reject(new Error('Company not found'));
                }
                const companyId = localStorage.getItem("companyId");
                const mvUrl = `${process.env.REACT_APP_COMMON_API_URL}companies(${companyId})/savedViews?$filter=(title eq 'generalSettings' and userID eq '${userData[0].id.toUpperCase()}')`;

                const savedViewRes = await apiService.get(mvUrl);
                if (savedViewRes?.value?.length > 0) {
                  await apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then((readResMV) => {
                    if (readResMV && "refreshTime" in readResMV) {
                      dataService.setLocalStorageData("refreshTime", readResMV.refreshTime)
                    } else {
                      dataService.setLocalStorageData("refreshTime", JSON.stringify(null))
                    }
                  })
                } else {
                  const postURL = `${process.env.REACT_APP_COMMON_API_URL}companies(${companyId})/savedViews`;
                  await apiService.post(postURL, { userID: userData[0].id, title: 'generalSettings' });
                }
                dataService.setLocalStorageData("userData", JSON.stringify(userData[0]));
                dataService.setLocalStorageData("userID", JSON.stringify(userData[0].id));
                dataService.setLocalStorageData("languageCode", JSON.stringify(userData[0].language));

                const filterableColumnURL = `${process.env.REACT_APP_COMMON_API_URL}companies(${companyId})/${filterableColumn}`
                const filterableData = await apiService.get(filterableColumnURL)

                if (filterableData !== null && filterableData !== undefined) {
                  if (!filterableData.error) {
                    dataService.setLocalStorageData("nonFilterableColumn", JSON.stringify(filterableData.grids))
                  }
                }

                await apiService.getODataMetadata().then(odataRes => {
                  dataService.setLocalStorageData('metaData', JSON.stringify(odataRes))
                })
                const entitiDefinationURL = `${process.env.REACT_APP_COMMON_API_URL}entityDefinitions?$schemaversion=2.0`;
                const entityDefination = await apiService.get(entitiDefinationURL);
                if (entityDefination?.value) {
                  const enumCaptions = [];
                  for (const value of entityDefination.value) {
                    if (value?.entityName && value?.enumMembers?.length > 0) {
                      const enums = {
                        entityName: value.entityName
                      };
                      const values = [];
                      const enumMembers = value?.enumMembers;
                      for (const enumMember of enumMembers) {
                        const value = {
                          name: enumMember?.name
                        };
                        const captions = enumMember?.captions;
                        for (const caption of captions) {
                          if (caption?.languageCode === 1033) {
                            value.caption = caption?.caption;
                          }
                        }
                        values.push(value);
                      }
                      enums.values = values;
                      enumCaptions.push(enums);
                    }
                  }
                  dataService.setLocalStorageData('enumCaptions', JSON.stringify(enumCaptions));
                }

                window.location.href = `${process.env.REACT_APP_REDIRECT_URL}#/dashboard`;                
                resolve();
              } else {
                window.location.href = `${process.env.REACT_APP_REDIRECT_URL}#/userNotFound`;
                return reject(new Error('User not found'));
              }
            }
          } catch (error) {
            console.error('API error:', error);
            reject(error);
          }
        });
      };
      fetchDataAndSetLocalStorage()
    }).catch(err => {
      console.log(err);      
      apiService.logOut()
    });
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    if (data.get('email') === "demo@dilx.com" && data.get('password') === 'Demo@1234') {
      localStorage.setItem('userID', '10000');
      dispatch(loginReducer(true))
      setTimeout(() => {
        navigate('/dashboard')
      }, 100)
    }
  };

  const initiateOAuthFlow = () => {
    const url = `${process.env.REACT_APP_AUTH_URL}?resource=${process.env.REACT_APP_CLIENT_ID}&response_type=token&client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_REDIRECT_URL}`;

    window.location.href = url;
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      {/* <Container component="main" maxWidth="xs"> */}

      {isLoading ? (<Spinner />) : (<></>)}
      <img src={bgIcon} alt="horse" />
      {/* <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={initiateOAuthFlow}
            >
              Sign In SSO
            </Button>
            <p style={{ textAlign: 'center' }}>Version: {process.env.REACT_APP_VERSION}</p>
          </Box>
        </Box> */}
      <Copyright sx={{ mt: 8, mb: 4 }} />
      {/* </Container> */}
    </ThemeProvider>
  );
}

export default Login;

